const STATUSES_IT = {
  added: "Aggiunto",
  archived: "Archiviato",
  canceled: "Annullato",
  complete: "Completo",
  confirmed: "In arrivo",
  ended: "Terminato",
  expired: "Scaduto",
  expires_soon: "Scade presto",
  incomplete: "Incompleto",
  paid: "Pagato",
  paymentToCome: "Pagamento in sospeso",
  pending: "In sospeso",
  proposed: "Proposto",
  refused: "Rifiutato",
  scheduled: "Da trattare",
  sent: "Da trattare",
  started: "Iniziato",
  to_add: "Da aggiungere",
  to_renew: "Da rinnovare",
  toAdd: "Da aggiungere",
  toCome: "In arrivo",
  toCorrect: "Da correggere",
  toJustify: "Da giustificare",
  toPay: "Da pagare",
  up_to_date: "Aggiornato",
  validated: "Convalidato",
  validationInProgress: "Validazione in corso",
  waiting_for_confirmation: "In arrivo",
  waiting_for_validation: "In corso",
} as const;

export default STATUSES_IT;
